import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

const CreateCampaign = ({ addCampaign, moment }) => {
  const [name, setName] = useState("");
  const [bonusInSek, setBonusInSek] = useState("");
  const [bonusInEur, setBonusInEur] = useState("");
  const [targetInSek, setTargetInSek] = useState("");
  const [targetInEur, setTargetInEur] = useState("");
  const [lengthInDays, setLengthInDays] = useState("");

  const [startDate, setStartDate] = useState(
    moment(new Date()).format("YYYY-MM-DDTHH:mm"),
  );
  const [endDate, setEndDate] = useState(
    moment(new Date())
      .set({
        hour: 23,
        minute: 59,
      })
      .format("YYYY-MM-DDTHH:mm"),
  );

  const clearFields = () => {
    setName("");
    setBonusInSek("");
    setBonusInEur("");
    setTargetInSek("");
    setTargetInEur("");
    setLengthInDays("");
    setStartDate(moment(new Date()).format("YYYY-MM-DDTHH:mm"));
    setEndDate(
      moment(new Date())
        .set({ hour: 23, minute: 59 })
        .format("YYYY-MM-DDTHH:mm"),
    );
  };
  return (
    <React.Fragment>
      <div style={{ padding: "20px 0" }}>
        <h3>Add new refer a friend campaign</h3>
      </div>

      <TextField
        className="textfield"
        style={{ margin: "5px" }}
        id="outlined-basic"
        label="name"
        value={name}
        variant="outlined"
        onChange={(event) => {
          setName(event.target.value);
        }}
      />
      <TextField
        className="textfield"
        style={{ margin: "5px" }}
        id="outlined-basic"
        label="bonusInSek"
        value={bonusInSek}
        onChange={(event) => {
          setBonusInSek(event.target.value);
        }}
        variant="outlined"
      />
      <TextField
        className="textfield"
        style={{ margin: "5px" }}
        id="outlined-basic"
        label="bonusInEur"
        value={bonusInEur}
        onChange={(event) => {
          setBonusInEur(event.target.value);
        }}
        variant="outlined"
      />
      <TextField
        className="textfield"
        style={{ margin: "5px" }}
        id="outlined-basic"
        label="target in sek"
        value={targetInSek}
        onChange={(event) => {
          setTargetInSek(event.target.value);
        }}
        variant="outlined"
      />
      <TextField
        className="textfield"
        style={{ margin: "5px" }}
        id="outlined-basic"
        label="target in eur"
        value={targetInEur}
        onChange={(event) => {
          setTargetInEur(event.target.value);
        }}
        variant="outlined"
      />
      <TextField
        className="textfield"
        style={{ margin: "5px" }}
        id="outlined-basic"
        label="days"
        value={lengthInDays}
        onChange={(event) => {
          setLengthInDays(event.target.value);
        }}
        variant="outlined"
      />
      <br />
      <TextField
        id="datetime-local"
        label="Start date swedish time"
        type="datetime-local"
        value={startDate}
        InputLabelProps={{
          shrink: true,
        }}
        onChange={(event) => {
          setStartDate(event.target.value);
        }}
      />

      <TextField
        id="datetime-local"
        label="End date swedish time"
        type="datetime-local"
        value={endDate}
        InputLabelProps={{
          shrink: true,
        }}
        onChange={(event) => {
          setEndDate(event.target.value);
        }}
      />

      <br />
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          const dto = {
            name,
            bonusInSek,
            bonusInEur,
            targetInSek,
            targetInEur,
            lengthInDays,
            startDate,
            endDate,
          };
          addCampaign(dto);
          clearFields();
        }}
      >
        Create new campaign
      </Button>
    </React.Fragment>
  );
};

export default CreateCampaign;
